import React from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

import { ROLES } from '../common/constants/appConstants'
import { PRACTICES_DETAILS, PRACTICES_REGISTER } from '../common/constants/routingConstants'
import { hasRole } from '../common/utils/utils'
import { getAuthRoles } from '../data/auth/authSelectors'
import { SentryRoutes } from '../index'
import PracticesDashboard from '../practices/dashboard/PracticesDashboard'
import PaymentsPracticeDetails from '../practices/individualPractice/paymentsAdmin/PaymentsPracticeDetails'
import ProvidersPracticeDetails from '../practices/individualPractice/providersAdmin/ProvidersPracticeDetails'
import RegisterPractice from '../practices/register/RegisterPractice'

const PracticesRoutes: React.FC = () => {
  const roles = useSelector(getAuthRoles)

  const getDashboard = () => {
    if (hasRole(roles, ROLES.PRACTICES_ADMIN)) {
      return <h1>PRACTICES_DASHBOARD, for Practice Admin </h1>
    } else if (hasRole(roles, [ROLES.PROVIDERS_ADMIN, ROLES.PAYMENTS_ADMIN])) {
      return <PracticesDashboard />
    } else if (hasRole(roles, ROLES.INDIVIDUAL_PROVIDER)) {
      return <h1>PRACTICES_DASHBOARD, for Individual Provider </h1>
    } else {
      return <h1>PRACTICES_DASHBOARD, default</h1>
    }
  }

  const getDetails = () => {
    if (hasRole(roles, ROLES.PROVIDERS_ADMIN)) {
      return <ProvidersPracticeDetails />
    } else if (hasRole(roles, ROLES.PAYMENTS_ADMIN)) {
      return <PaymentsPracticeDetails />
    } else {
      return <h1>PRACTICE_DETAILS, default</h1>
    }
  }

  return (
    <div>
      <ContentLayout>
        <div style={{ marginTop: '50px' }}>
          <SentryRoutes>
            <Route path='/' element={getDashboard()} />
            <Route path={`${PRACTICES_DETAILS.subroute}/*`} element={getDetails()} />
            <Route path={PRACTICES_REGISTER.subroute} element={<RegisterPractice />} />
          </SentryRoutes>
        </div>
      </ContentLayout>
    </div>
  )
}

export default PracticesRoutes
